import {TOKENS} from '../../tokens'

export const bg = {
  dark: {
    default: TOKENS.dark.custom_background_primary,
    contrast_25: TOKENS.dark.contrast_25,
    contrast_50: TOKENS.dark.contrast_50,
    contrast_100: TOKENS.dark.contrast_100,
  },
  light: {
    default: TOKENS.light.contrast_0,
    contrast_25: TOKENS.light.contrast_25,
    contrast_50: TOKENS.light.contrast_50,
    contrast_100: TOKENS.light.contrast_100,
  },
} as const
